export default "{\n    \"resQCompany\": \"Get ResQ US Ltd.\",\n    \"street\": \"251 Little Falls Drive\",\n    \"area\": \"Wilmington, Delaware, 19808\"\n}\n"